import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import CompanyMarketProductsPage, { MarketConfiguration } from './CompanyMarketProducts';

const fashionFinderConfiguration: MarketConfiguration = {
  marketId: 8,
  breadcrumbRoute: 'company-profile-fashion-finder',
  titleMessageKey: 'company-profile-fashion-finder.title',
  productRoute: 'fashion-finder-product',
};

const companyFashionFinderPagePropertyTypes = {
  slug: PropTypes.string.isRequired,
};

type CompanyFashionFinderPageProperties = InferProps<
  typeof companyFashionFinderPagePropertyTypes
>;

const CompanyFashionFinderPage = (
  { slug }: CompanyFashionFinderPageProperties,
) => (
  <CompanyMarketProductsPage
    slug={slug}
    configuration={fashionFinderConfiguration}
  />
);

CompanyFashionFinderPage.propTypes = companyFashionFinderPagePropertyTypes;

export default CompanyFashionFinderPage;
